var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g5, _path37, _path38, _path39, _path40, _path41, _g6, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g7, _path54, _path55, _path56, _path57, _path58, _path59, _g8, _path60, _path61, _path62, _path63, _path64, _path65, _g9, _path66, _path67, _path68, _path69, _path70, _path71, _g10, _path72, _path73, _path74, _path75, _path76, _path77, _g11, _path78, _path79, _path80, _path81, _path82, _path83, _g12, _path84, _path85, _path86, _path87, _path88, _path89, _g13, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g14, _path97, _path98, _path99, _path100, _path101, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 174,
    viewBox: "0 0 375 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12311_88307)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 173.616,
    fill: "#F2F8FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 74,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 88C63.4345 88 80 71.4345 80 51C80 30.5655 63.4345 14 43 14C22.5655 14 6 30.5655 6 51C6 71.4345 22.5655 88 43 88Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12311_88307)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88C63.4345 88 80 71.4345 80 51C80 30.5655 63.4345 14 43 14C22.5655 14 6 30.5655 6 51C6 71.4345 22.5655 88 43 88Z",
    fill: "#17B7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0038 23.5481C50.8845 23.5481 57.2731 29.9367 57.2731 37.8175V38.0565C57.2731 45.9373 50.8845 52.3259 43.0038 52.3259C35.123 52.3259 28.7344 45.9373 28.7344 38.0565V37.8175C28.7344 29.9367 35.123 23.5481 43.0038 23.5481Z",
    fill: "#9D4000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9277 65.1614C31.5821 63.6388 36.6067 62.8774 43.0018 62.8774C49.3969 62.8774 53.8125 63.6388 56.2487 65.1614L43.4586 80.6923L27.9277 65.1614Z",
    fill: "#686868"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 54,
    width: 71,
    height: 100
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4808 54.5573C51.1937 57.8422 51.0501 60.5244 51.0501 62.6038C51.0501 66.3534 55.7664 69.7091 65.1989 72.6712C69.954 74.1644 73.4261 78.2597 74.1212 83.195L78.488 114.199L70.8709 114.56H66.4097L62.8408 142.22L53.9184 153.819H31.6123L22.6899 142.22L20.0132 114.56L8.41406 114.199L12.0521 83.4248C12.6492 78.3741 16.154 74.1437 21.0055 72.6177C30.3083 69.6915 34.9597 66.4183 34.9597 62.798C34.9597 60.7286 34.8161 57.8279 34.529 54.0957L51.4808 54.5573Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4808 54.5571C51.1937 57.842 51.0501 60.5241 51.0501 62.6035C51.0501 66.3531 55.7664 69.7089 65.1989 72.6709C69.954 74.1641 73.4261 78.2594 74.1212 83.1948L78.488 114.199L70.8709 114.56H66.4097L62.8408 142.219L53.9184 153.818H31.6123L22.6899 142.219L20.0132 114.56L8.41406 114.199L12.0521 83.4245C12.6492 78.3739 16.154 74.1434 21.0055 72.6174C30.3083 69.6913 34.9597 66.4181 34.9597 62.7978C34.9597 60.7284 34.8161 57.8276 34.529 54.0955L51.4808 54.5571Z",
    fill: "#FDE5BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1831 65.1833C28.831 71.8516 35.1766 75.1477 43.2199 75.0718C51.2631 74.9958 57.4652 71.6997 61.826 65.1833L72.9338 72.4586L78.4876 114.276H66.4094L63.7327 142.219L54.8103 152.926H32.5042L22.6896 142.219L20.0129 114.276H7.52148L13.0754 73.014L24.1831 65.1833Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5203 29.7969C51.585 29.7969 56.5015 34.7133 56.5015 40.7781V52.4053C56.5015 58.47 51.585 63.3865 45.5203 63.3865C39.4555 63.3865 34.5391 58.47 34.5391 52.4053V40.7781C34.5391 34.7133 39.4555 29.7969 45.5203 29.7969Z",
    fill: "#FAD2A2"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0047 26.9651C49.0694 26.9651 53.9859 31.8815 53.9859 37.9463V49.5735C53.9859 55.6382 49.0694 60.5547 43.0047 60.5547C36.9399 60.5547 32.0234 55.6382 32.0234 49.5735V37.9463C32.0234 31.8815 36.9399 26.9651 43.0047 26.9651Z",
    fill: "#FDE5BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4167 42.4678H53.1248C51.6978 42.4678 50.541 43.6246 50.541 45.0516V47.7139C50.541 49.1409 51.6978 50.2977 53.1248 50.2977H54.4167C55.8437 50.2977 57.0006 49.1409 57.0006 47.7139V45.0516C57.0006 43.6246 55.8437 42.4678 54.4167 42.4678Z",
    fill: "#FDE5BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8835 42.4678H31.5916C30.1646 42.4678 29.0078 43.6246 29.0078 45.0516V47.7139C29.0078 49.1409 30.1646 50.2977 31.5916 50.2977H32.8835C34.3105 50.2977 35.4674 49.1409 35.4674 47.7139V45.0516C35.4674 43.6246 34.3105 42.4678 32.8835 42.4678Z",
    fill: "#FDE5BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8173 44.7884C49.5308 44.7884 50.1092 44.21 50.1092 43.4965C50.1092 42.783 49.5308 42.2046 48.8173 42.2046C48.1038 42.2046 47.5254 42.783 47.5254 43.4965C47.5254 44.21 48.1038 44.7884 48.8173 44.7884Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 52,
    width: 10,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2331 52.8611C44.6903 52.8611 46.1476 52.9433 47.6048 53.1078C46.1476 54.8322 44.6903 55.6944 43.2331 55.6944C41.7758 55.6944 40.3186 54.8322 38.8613 53.1078C40.3186 52.9433 41.7758 52.8611 43.2331 52.8611Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2331 52.8613C44.6903 52.8613 46.1476 52.9436 47.6048 53.1081C46.1476 54.8324 44.6903 55.6946 43.2331 55.6946C41.7758 55.6946 40.3186 54.8324 38.8613 53.1081C40.3186 52.9436 41.7758 52.8613 43.2331 52.8613Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1903 44.7879C37.9038 44.7879 38.4823 44.2095 38.4823 43.496C38.4823 42.7825 37.9038 42.2041 37.1903 42.2041C36.4768 42.2041 35.8984 42.7825 35.8984 43.496C35.8984 44.2095 36.4768 44.7879 37.1903 44.7879Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2421 49.8501C44.6119 49.8501 45.7224 49.2042 45.7224 48.9578C45.7224 48.7115 44.6119 48.5117 43.2421 48.5117C41.8722 48.5117 40.7617 48.7115 40.7617 48.9578C40.7617 49.2042 41.8722 49.8501 43.2421 49.8501Z",
    fill: "#FAD2A2"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.123 41.4073L32.0366 45.5184C32.6457 42.7814 32.9502 40.4974 32.9502 38.6666C32.9502 36.8358 32.6457 35.0086 32.0366 33.1851C33.2547 35.9259 35.5387 36.9917 38.8885 36.3826C42.2383 35.7736 47.5675 34.7077 54.8761 33.1851C53.8295 34.4381 53.2205 36.2653 53.049 38.6666C52.8774 41.0679 53.182 43.5041 53.9626 45.9752L54.8761 41.4073L56.2465 33.1851L43.4564 24.5061L31.123 32.2715V41.4073Z",
    fill: "#9D4000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9512 72.0125H53.9635C46.0458 77.1894 42.087 79.7779 42.087 79.7779C42.087 79.7779 39.0417 77.1894 32.9512 72.0125Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4567 78.4073L56.2468 65.1604L62.1851 69.7283L58.9875 78.4073L43.9135 82.5184L27.9258 78.4073L24.2715 69.7283L27.9258 65.1604L43.4567 78.4073Z",
    fill: "#9B9B9B"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12311_88307)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 14,
    width: 75,
    height: 74
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.863 88C165.298 88 181.863 71.4345 181.863 51C181.863 30.5655 165.298 14 144.863 14C124.429 14 107.863 30.5655 107.863 51C107.863 71.4345 124.429 88 144.863 88Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12311_88307)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.863 88C165.298 88 181.863 71.4345 181.863 51C181.863 30.5655 165.298 14 144.863 14C124.429 14 107.863 30.5655 107.863 51C107.863 71.4345 124.429 88 144.863 88Z",
    fill: "#031D43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.867 22.1746C152.748 22.1746 159.136 28.5632 159.136 36.4439V38.0533C159.136 45.9341 152.748 52.3227 144.867 52.3227C136.986 52.3227 130.598 45.9341 130.598 38.0533V36.4439C130.598 28.5632 136.986 22.1746 144.867 22.1746Z",
    fill: "#9D4000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 54,
    width: 71,
    height: 100
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.258 54.5539C153.971 57.8388 153.827 60.521 153.827 62.6004C153.827 66.3213 159.247 69.6544 170.087 72.5998C175.598 74.0972 179.472 79.0351 179.615 84.744L180.351 114.196L172.734 114.557H168.273L164.704 142.216L155.782 153.815H133.476L124.553 142.216L121.876 114.557L110.277 114.196L110.347 84.982C110.361 79.1648 114.261 74.0743 119.874 72.5469C130.564 69.6379 135.909 66.3871 135.909 62.7946C135.909 60.7252 135.766 57.8245 135.479 54.0923L154.258 54.5539Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.258 54.5536C153.971 57.8386 153.827 60.5207 153.827 62.6001C153.827 66.3211 159.247 69.6542 170.087 72.5996C175.598 74.0969 179.472 79.0348 179.615 84.7437L180.351 114.195L172.734 114.556H168.273L164.704 142.216L155.782 153.815H133.476L124.553 142.216L121.876 114.556L110.277 114.195L110.347 84.9817C110.361 79.1645 114.261 74.074 119.874 72.5466C130.564 69.6377 135.909 66.3869 135.909 62.7943C135.909 60.725 135.766 57.8242 135.479 54.092L154.258 54.5536Z",
    fill: "#CD8B52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.046 64.2664C132.746 70.9515 139.171 74.2941 145.321 74.2941C151.471 74.2941 157.594 70.9515 163.689 64.2664L174.797 71.5416L180.351 113.359H168.273L165.596 141.302L156.674 152.009H134.368L124.553 141.302L121.876 113.359H109.385L114.939 72.097L126.046 64.2664Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.384 29.7935C153.448 29.7935 158.365 34.7099 158.365 40.7747V52.4018C158.365 58.4666 153.448 63.3831 147.384 63.3831C141.319 63.3831 136.402 58.4666 136.402 52.4018V40.7747C136.402 34.7099 141.319 29.7935 147.384 29.7935Z",
    fill: "#CB793D"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.868 26.9619C150.933 26.9619 155.849 31.8784 155.849 37.9431V49.5703C155.849 55.6351 150.933 60.5515 144.868 60.5515C138.803 60.5515 133.887 55.6351 133.887 49.5703V37.9431C133.887 31.8784 138.803 26.9619 144.868 26.9619Z",
    fill: "#CD8B52"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.28 42.4646H154.988C153.561 42.4646 152.404 43.6214 152.404 45.0484V47.7107C152.404 49.1377 153.561 50.2945 154.988 50.2945H156.28C157.707 50.2945 158.864 49.1377 158.864 47.7107V45.0484C158.864 43.6214 157.707 42.4646 156.28 42.4646Z",
    fill: "#CD8B52"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M134.747 42.4646H133.455C132.028 42.4646 130.871 43.6214 130.871 45.0484V47.7107C130.871 49.1377 132.028 50.2945 133.455 50.2945H134.747C136.174 50.2945 137.331 49.1377 137.331 47.7107V45.0484C137.331 43.6214 136.174 42.4646 134.747 42.4646Z",
    fill: "#CD8B52"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.681 45.2415C151.394 45.2415 151.972 44.6631 151.972 43.9496C151.972 43.2361 151.394 42.6577 150.681 42.6577C149.967 42.6577 149.389 43.2361 149.389 43.9496C149.389 44.6631 149.967 45.2415 150.681 45.2415Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.705 37.2941L129.791 28.6151H132.532V24.0472H136.186V20.3928L141.668 22.22V18.5657L152.174 24.0472L152.631 21.3064L157.198 26.3311H158.569V32.7262H160.396L158.569 39.1212L153.544 28.6151L143.495 24.9607L136.186 28.6151L130.705 37.2941Z",
    fill: "#9D4000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.445 35.0101H156.285L154.914 26.7879L144.865 25.4175L134.816 29.0718L133.445 35.0101Z",
    fill: "#9D4000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 53,
    width: 8,
    height: 3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.095 53.772C146.248 53.772 147.4 53.8277 148.553 53.9391C147.4 55.1075 146.248 55.6917 145.095 55.6917C143.942 55.6917 142.789 55.1075 141.637 53.9391C142.789 53.8277 143.942 53.772 145.095 53.772Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.095 53.7722C146.248 53.7722 147.4 53.8279 148.553 53.9394C147.4 55.1078 146.248 55.692 145.095 55.692C143.942 55.692 142.789 55.1078 141.637 53.9394C142.789 53.8279 143.942 53.7722 145.095 53.7722Z",
    fill: "white"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.054 45.242C139.767 45.242 140.346 44.6636 140.346 43.9501C140.346 43.2366 139.767 42.6582 139.054 42.6582C138.34 42.6582 137.762 43.2366 137.762 43.9501C137.762 44.6636 138.34 45.242 139.054 45.242Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M143.266 43.0042H146.463",
    stroke: "#211E1F",
    strokeWidth: 0.685185,
    strokeLinecap: "square"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.4 42.2048C142.558 42.2048 142.7 42.2687 142.804 42.3721C142.901 42.4695 142.964 42.6021 142.97 42.7491L142.38 46.0755C142.356 46.2112 142.284 46.3285 142.184 46.4117C142.085 46.495 141.957 46.5443 141.819 46.5443H136.643C136.233 46.5443 135.862 46.3782 135.593 46.1095C135.324 45.8409 135.158 45.4697 135.158 45.0598V42.7758C135.158 42.6181 135.222 42.4754 135.325 42.3721C135.429 42.2687 135.572 42.2048 135.729 42.2048H142.4Z",
    stroke: "#211E1F",
    strokeWidth: 0.685185
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.331 42.2048C147.173 42.2048 147.03 42.2687 146.927 42.3721C146.829 42.4695 146.767 42.6021 146.76 42.7491L147.35 46.0755C147.375 46.2112 147.446 46.3285 147.546 46.4117C147.646 46.495 147.774 46.5443 147.912 46.5443H153.088C153.498 46.5443 153.869 46.3782 154.137 46.1095C154.406 45.8409 154.572 45.4697 154.572 45.0598V42.7758C154.572 42.6181 154.508 42.4754 154.405 42.3721C154.302 42.2687 154.159 42.2048 154.001 42.2048H147.331Z",
    stroke: "#211E1F",
    strokeWidth: 0.685185
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.105 50.7624C146.475 50.7624 147.586 50.1166 147.586 49.8702C147.586 49.6238 146.475 49.4241 145.105 49.4241C143.735 49.4241 142.625 49.6238 142.625 49.8702C142.625 50.1166 143.735 50.7624 145.105 50.7624Z",
    fill: "#CB793D"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.07 59.5767C142.674 59.6185 140.706 58.1867 140.723 59.1957C140.741 60.2047 142.73 62.8156 145.126 62.7737C147.522 62.7319 149.419 60.0532 149.401 59.0442C149.383 58.0353 147.466 59.5349 145.07 59.5767Z",
    fill: "#9D4000"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_12311_88307)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 14,
    width: 75,
    height: 74
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M238.963 88C259.397 88 275.963 71.4345 275.963 51C275.963 30.5655 259.397 14 238.963 14C218.528 14 201.963 30.5655 201.963 51C201.963 71.4345 218.528 88 238.963 88Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_12311_88307)"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M238.963 88C259.397 88 275.963 71.4345 275.963 51C275.963 30.5655 259.397 14 238.963 14C218.528 14 201.963 30.5655 201.963 51C201.963 71.4345 218.528 88 238.963 88Z",
    fill: "#D2EFF9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.967 22.1765C246.847 22.1765 253.236 28.5651 253.236 36.4459V38.0553C253.236 45.936 246.847 52.3247 238.967 52.3247C231.086 52.3247 224.697 45.936 224.697 38.0553V36.4459C224.697 28.5651 231.086 22.1765 238.967 22.1765Z",
    fill: "#211E1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 54,
    width: 71,
    height: 100
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M248.357 54.5561C248.07 57.841 247.927 60.5232 247.927 62.6026C247.927 66.3235 253.347 69.6566 264.187 72.602C269.698 74.0994 273.572 79.0373 273.714 84.7462L274.451 114.198L266.834 114.559H262.373L258.804 142.218L249.881 153.818H227.575L218.653 142.218L215.976 114.559L204.377 114.198L204.446 84.9842C204.46 79.167 208.36 74.0765 213.973 72.5491C224.664 69.6401 230.009 66.3893 230.009 62.7968C230.009 60.7274 229.865 57.8267 229.578 54.0945L248.357 54.5561Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.357 54.5558C248.07 57.8408 247.927 60.5229 247.927 62.6023C247.927 66.3233 253.347 69.6564 264.187 72.6018C269.698 74.0991 273.572 79.037 273.714 84.7459L274.451 114.197L266.834 114.559H262.373L258.804 142.218L249.881 153.817H227.575L218.653 142.218L215.976 114.559L204.377 114.197L204.446 84.9839C204.46 79.1667 208.36 74.0762 213.973 72.5488C224.664 69.6399 230.009 66.3891 230.009 62.7965C230.009 60.7272 229.865 57.8264 229.578 54.0942L248.357 54.5558Z",
    fill: "#9C5620"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.146 56.5029L237.006 65.2606L239.421 72.0122L241.452 65.1855L257.789 56.5029L268.897 63.7782L274.451 105.595H262.372L259.696 133.539L250.773 144.246H228.467L218.652 133.539L215.976 105.595H203.484L209.038 64.3336L220.146 56.5029Z",
    fill: "#FDE5BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.483 29.7957C247.548 29.7957 252.464 34.7121 252.464 40.7769V52.404C252.464 58.4688 247.548 63.3853 241.483 63.3853C235.418 63.3853 230.502 58.4688 230.502 52.404V40.7769C230.502 34.7121 235.418 29.7957 241.483 29.7957Z",
    fill: "#9D4000"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.968 26.9639C245.032 26.9639 249.949 31.8803 249.949 37.9451V49.5723C249.949 55.637 245.032 60.5535 238.968 60.5535C232.903 60.5535 227.986 55.637 227.986 49.5723V37.9451C227.986 31.8803 232.903 26.9639 238.968 26.9639Z",
    fill: "#9C5620"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 42.4666H249.088C247.661 42.4666 246.504 43.6234 246.504 45.0504V47.7126C246.504 49.1396 247.661 50.2965 249.088 50.2965H250.38C251.807 50.2965 252.963 49.1396 252.963 47.7126V45.0504C252.963 43.6234 251.807 42.4666 250.38 42.4666Z",
    fill: "#9C5620"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M228.846 42.4666H227.555C226.128 42.4666 224.971 43.6234 224.971 45.0504V47.7126C224.971 49.1396 226.128 50.2965 227.555 50.2965H228.846C230.273 50.2965 231.43 49.1396 231.43 47.7126V45.0504C231.43 43.6234 230.273 42.4666 228.846 42.4666Z",
    fill: "#9C5620"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M244.78 45.244C245.494 45.244 246.072 44.6656 246.072 43.9521C246.072 43.2386 245.494 42.6602 244.78 42.6602C244.067 42.6602 243.488 43.2386 243.488 43.9521C243.488 44.6656 244.067 45.244 244.78 45.244Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 53,
    width: 8,
    height: 3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M239.194 53.3191C240.347 53.3191 241.5 53.3748 242.653 53.4863C241.5 54.6546 240.347 55.2388 239.194 55.2388C238.042 55.2388 236.889 54.6546 235.736 53.4863C236.889 53.3748 238.042 53.3191 239.194 53.3191Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.194 53.3186C240.347 53.3186 241.5 53.3743 242.653 53.4858C241.5 54.6542 240.347 55.2383 239.194 55.2383C238.042 55.2383 236.889 54.6542 235.736 53.4858C236.889 53.3743 238.042 53.3186 239.194 53.3186Z",
    fill: "white"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M233.153 45.2445C233.867 45.2445 234.445 44.6661 234.445 43.9526C234.445 43.2391 233.867 42.6606 233.153 42.6606C232.44 42.6606 231.861 43.2391 231.861 43.9526C231.861 44.6661 232.44 45.2445 233.153 45.2445Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.205 49.8496C240.575 49.8496 241.685 49.2037 241.685 48.9574C241.685 48.711 240.575 48.5112 239.205 48.5112C237.835 48.5112 236.725 48.711 236.725 48.9574C236.725 49.2037 237.835 49.8496 239.205 49.8496Z",
    fill: "#9D4000"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.086 40.037L228 44.1481C228.609 41.411 228.913 39.127 228.913 37.2962C228.913 35.4654 228.609 33.6383 228 31.8148C231.958 30.2921 234.395 31.0534 235.308 34.0987C236.222 37.144 239.876 37.4485 246.271 35.0123C248.27 34.1336 249.183 34.8949 249.012 37.2962C248.84 39.6976 249.145 42.1338 249.925 44.6049L250.839 40.037L252.209 31.8148L239.419 23.1357L227.086 30.9012V40.037Z",
    fill: "#211E1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M239.419 78.4075C239.924 78.4075 240.333 77.9985 240.333 77.4939C240.333 76.9893 239.924 76.5803 239.419 76.5803C238.915 76.5803 238.506 76.9893 238.506 77.4939C238.506 77.9985 238.915 78.4075 239.419 78.4075Z",
    fill: "#CD8B52"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M239.419 84.8025C239.924 84.8025 240.333 84.3935 240.333 83.8889C240.333 83.3844 239.924 82.9753 239.419 82.9753C238.915 82.9753 238.506 83.3844 238.506 83.8889C238.506 84.3935 238.915 84.8025 239.419 84.8025Z",
    fill: "#CD8B52"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.16 66.9875L244.901 73.3826L248.098 69.2715L244.901 71.0987L242.16 66.9875Z",
    fill: "#CD8B52"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.223 66.9875L233.482 73.3826L230.284 69.2715L233.482 71.0987L236.223 66.9875Z",
    fill: "#CD8B52"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.419 53.284C242.698 53.284 245.357 54.7499 245.357 53.7407C245.357 52.7316 242.698 50.0864 239.419 50.0864C236.139 50.0864 233.48 52.7316 233.48 53.7407C233.48 54.7499 236.139 53.284 239.419 53.284Z",
    fill: "#211E1F"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_12311_88307)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 109,
    width: 75,
    height: 74
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M181.605 183C202.04 183 218.605 166.435 218.605 146C218.605 125.565 202.04 109 181.605 109C161.171 109 144.605 125.565 144.605 146C144.605 166.435 161.171 183 181.605 183Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_12311_88307)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M181.605 183C202.04 183 218.605 166.435 218.605 146C218.605 125.565 202.04 109 181.605 109C161.171 109 144.605 125.565 144.605 146C144.605 166.435 161.171 183 181.605 183Z",
    fill: "#29B8FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.462 113.566H182.759C193.224 113.566 201.707 122.049 201.707 132.514C201.707 132.543 201.707 132.573 201.707 132.603C201.706 132.906 201.704 133.212 201.701 133.521C201.619 143.092 197.085 149.839 188.097 153.763H175.116C166.129 149.201 161.597 142.454 161.52 133.521C161.517 133.209 161.515 132.899 161.514 132.593C161.47 122.128 169.918 113.609 180.383 113.566C180.409 113.566 180.435 113.566 180.462 113.566Z",
    fill: "#211E1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 149,
    width: 71,
    height: 100
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M188.716 149.554C188.429 152.839 188.285 155.521 188.285 157.6C188.285 161.382 193.383 164.763 203.58 167.744C208.453 169.169 212.04 173.315 212.748 178.342L217.093 209.196L209.476 209.557H205.015L201.446 237.216L192.524 248.815H170.218L161.295 237.216L158.619 209.557L147.02 209.196L150.639 178.575C151.247 173.432 154.869 169.148 159.839 167.693C169.903 164.747 174.936 161.447 174.936 157.795C174.936 155.725 174.792 152.824 174.505 149.092L188.716 149.554Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.716 149.554C188.429 152.839 188.285 155.521 188.285 157.6C188.285 161.382 193.383 164.763 203.58 167.744C208.453 169.168 212.04 173.315 212.748 178.342L217.093 209.195L209.476 209.556H205.015L201.446 237.216L192.524 248.815H170.218L161.295 237.216L158.619 209.556L147.02 209.195L150.639 178.575C151.247 173.431 154.869 169.148 159.839 167.693C169.903 164.747 174.936 161.447 174.936 157.794C174.936 155.725 174.792 152.824 174.505 149.092L188.716 149.554Z",
    fill: "#CC8B57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.789 160.18C172.898 165.952 179.323 168.837 182.063 168.837C184.804 168.837 190.927 165.952 200.431 160.18L211.539 167.455L217.093 209.272H205.015L202.338 237.216L193.416 247.923H171.11L161.295 237.216L158.618 209.272H146.127L151.681 168.011L162.789 160.18Z",
    fill: "#FDE5BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.126 124.793C190.191 124.793 195.107 129.71 195.107 135.775V147.402C195.107 153.467 190.191 158.383 184.126 158.383C178.061 158.383 173.145 153.467 173.145 147.402V135.775C173.145 129.71 178.061 124.793 184.126 124.793Z",
    fill: "#CB793D"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.61 121.962C187.675 121.962 192.591 126.878 192.591 132.943V144.57C192.591 150.635 187.675 155.552 181.61 155.552C175.545 155.552 170.629 150.635 170.629 144.57V132.943C170.629 126.878 175.545 121.962 181.61 121.962Z",
    fill: "#CC8B57"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M193.022 137.465H191.73C190.303 137.465 189.146 138.621 189.146 140.048V141.34C189.146 142.767 190.303 143.924 191.73 143.924H193.022C194.449 143.924 195.606 142.767 195.606 141.34V140.048C195.606 138.621 194.449 137.465 193.022 137.465Z",
    fill: "#CC8B57"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M171.489 137.465H170.197C168.77 137.465 167.613 138.621 167.613 140.048V141.34C167.613 142.767 168.77 143.924 170.197 143.924H171.489C172.916 143.924 174.073 142.767 174.073 141.34V140.048C174.073 138.621 172.916 137.465 171.489 137.465Z",
    fill: "#CC8B57"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.629 121.9L181.395 118.024L192.591 121.9L193.883 125.345L192.591 127.543C189.725 129.393 186.064 130.368 181.607 130.467C177.15 130.566 173.49 129.976 170.629 128.698L168.906 129.651L170.629 121.9Z",
    fill: "#211E1F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M187.423 140.698C188.136 140.698 188.715 140.12 188.715 139.406C188.715 138.693 188.136 138.115 187.423 138.115C186.709 138.115 186.131 138.693 186.131 139.406C186.131 140.12 186.709 140.698 187.423 140.698Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 148,
    width: 9,
    height: 4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M181.608 148.315C182.837 148.315 184.066 148.398 185.295 148.562C184.066 150.287 182.837 151.149 181.608 151.149C180.38 151.149 179.151 150.287 177.922 148.562C179.151 148.398 180.38 148.315 181.608 148.315Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.608 148.315C182.837 148.315 184.066 148.398 185.295 148.562C184.066 150.287 182.837 151.149 181.608 151.149C180.38 151.149 179.151 150.287 177.922 148.562C179.151 148.398 180.38 148.315 181.608 148.315Z",
    fill: "#9D4000"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M175.796 140.699C176.509 140.699 177.088 140.12 177.088 139.407C177.088 138.693 176.509 138.115 175.796 138.115C175.082 138.115 174.504 138.693 174.504 139.407C174.504 140.12 175.082 140.699 175.796 140.699Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.619 145.762C182.863 145.762 183.871 145.117 183.871 144.87C183.871 144.624 182.863 144.424 181.619 144.424C180.375 144.424 179.367 144.624 179.367 144.87C179.367 145.117 180.375 145.762 181.619 145.762Z",
    fill: "#CB793D"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_12311_88307)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 14,
    width: 75,
    height: 74
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M331.691 88C352.126 88 368.691 71.4345 368.691 51C368.691 30.5655 352.126 14 331.691 14C311.257 14 294.691 30.5655 294.691 51C294.691 71.4345 311.257 88 331.691 88Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_12311_88307)"
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M331.691 88C352.126 88 368.691 71.4345 368.691 51C368.691 30.5655 352.126 14 331.691 14C311.257 14 294.691 30.5655 294.691 51C294.691 71.4345 311.257 88 331.691 88Z",
    fill: "#29B8FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.696 21.7644C341.09 21.7644 348.706 29.3801 348.706 38.7745V75.1633H314.686V38.7745C314.686 29.3801 322.301 21.7644 331.696 21.7644Z",
    fill: "#211E1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 297,
    y: 54,
    width: 71,
    height: 100
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M338.802 54.5551C338.515 57.84 338.371 60.5222 338.371 62.6016C338.371 66.3834 343.469 69.7647 353.666 72.7454C358.539 74.1699 362.126 78.3164 362.834 83.3437L367.179 114.197L359.562 114.558H355.101L351.532 142.217L342.61 153.817H320.304L311.381 142.217L308.705 114.558L297.105 114.197L300.725 83.5764C301.333 78.4328 304.955 74.1495 309.925 72.6944C319.989 69.7482 325.021 66.4487 325.021 62.7958C325.021 60.7264 324.878 57.8257 324.591 54.0935L338.802 54.5551Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.802 54.5549C338.515 57.8398 338.371 60.5219 338.371 62.6013C338.371 66.3832 343.469 69.7645 353.666 72.7451C358.539 74.1696 362.126 78.3162 362.834 83.3435L367.179 114.196L359.562 114.558H355.101L351.532 142.217L342.61 153.816H320.304L311.381 142.217L308.705 114.558L297.105 114.196L300.725 83.5761C301.333 78.4325 304.955 74.1493 309.925 72.6941C319.989 69.748 325.021 66.4484 325.021 62.7956C325.021 60.7262 324.878 57.8254 324.591 54.0933L338.802 54.5549Z",
    fill: "#F8C9A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.875 65.1812C317.522 71.8494 323.868 75.1455 331.911 75.0696C339.955 74.9936 346.157 71.6975 350.517 65.1812L361.625 72.4564L367.179 114.274H355.101L352.424 142.217L343.502 152.924H321.196L311.381 142.217L308.704 114.274H296.213L301.767 73.0118L312.875 65.1812Z",
    fill: "#00539D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.212 29.7947C340.276 29.7947 345.193 34.7111 345.193 40.7759V52.4031C345.193 58.4678 340.276 63.3843 334.212 63.3843C328.147 63.3843 323.23 58.4678 323.23 52.4031V40.7759C323.23 34.7111 328.147 29.7947 334.212 29.7947Z",
    fill: "#FBB68E"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.696 26.9631C337.761 26.9631 342.677 31.8796 342.677 37.9444V49.5715C342.677 55.6363 337.761 60.5527 331.696 60.5527C325.631 60.5527 320.715 55.6363 320.715 49.5715V37.9444C320.715 31.8796 325.631 26.9631 331.696 26.9631Z",
    fill: "#F8C9A8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M343.108 42.4658H341.816C340.389 42.4658 339.232 43.6226 339.232 45.0496V46.3415C339.232 47.7685 340.389 48.9254 341.816 48.9254H343.108C344.535 48.9254 345.692 47.7685 345.692 46.3415V45.0496C345.692 43.6226 344.535 42.4658 343.108 42.4658Z",
    fill: "#F8C9A8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M321.575 42.4658H320.283C318.856 42.4658 317.699 43.6226 317.699 45.0496V46.3415C317.699 47.7685 318.856 48.9254 320.283 48.9254H321.575C323.002 48.9254 324.159 47.7685 324.159 46.3415V45.0496C324.159 43.6226 323.002 42.4658 321.575 42.4658Z",
    fill: "#F8C9A8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.715 26.9011L331.481 23.0254L342.677 26.9011L343.969 30.3462L342.677 32.5439C339.55 33.4069 336.248 35.0403 332.773 37.4443C329.297 39.8482 325.278 41.645 320.715 42.8346L318.992 34.6526L320.715 26.9011Z",
    fill: "#211E1F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M337.509 45.6995C338.222 45.6995 338.801 45.1211 338.801 44.4076C338.801 43.6941 338.222 43.1157 337.509 43.1157C336.795 43.1157 336.217 43.6941 336.217 44.4076C336.217 45.1211 336.795 45.6995 337.509 45.6995Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 53,
    width: 7,
    height: 4
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M331.695 53.3162C332.771 53.3162 333.848 53.3984 334.924 53.5629C333.848 55.2873 332.771 56.1495 331.695 56.1495C330.618 56.1495 329.541 55.2873 328.465 53.5629C329.541 53.3984 330.618 53.3162 331.695 53.3162Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.695 53.3162C332.771 53.3162 333.848 53.3984 334.924 53.5629C333.848 55.2873 332.771 56.1495 331.695 56.1495C330.618 56.1495 329.541 55.2873 328.465 53.5629C329.541 53.3984 330.618 53.3162 331.695 53.3162Z",
    fill: "#E75C00"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M325.882 45.6993C326.595 45.6993 327.174 45.1209 327.174 44.4074C327.174 43.6939 326.595 43.1155 325.882 43.1155C325.168 43.1155 324.59 43.6939 324.59 44.4074C324.59 45.1209 325.168 45.6993 325.882 45.6993Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.706 50.7627C332.445 50.7627 333.044 50.1168 333.044 49.8704C333.044 49.6241 332.445 49.4243 331.706 49.4243C330.966 49.4243 330.367 49.6241 330.367 49.8704C330.367 50.1168 330.966 50.7627 331.706 50.7627Z",
    fill: "#FBB68E"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 109,
    width: 74,
    height: 74
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M77 183C97.4345 183 114 166.435 114 146C114 125.565 97.4345 109 77 109C56.5655 109 40 125.565 40 146C40 166.435 56.5655 183 77 183Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_12311_88307)"
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M77 183C97.4345 183 114 166.435 114 146C114 125.565 97.4345 109 77 109C56.5655 109 40 125.565 40 146C40 166.435 56.5655 183 77 183Z",
    fill: "#031D43"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0043 116.764C86.3987 116.764 94.0144 124.38 94.0144 133.775V170.163H59.9941V133.775C59.9941 124.38 67.6098 116.764 77.0043 116.764Z",
    fill: "#F13C12"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 149,
    width: 71,
    height: 100
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1104 149.555C83.8233 152.84 83.6797 155.522 83.6797 157.602C83.6797 161.383 88.778 164.765 98.9745 167.745C103.847 169.17 107.434 173.316 108.142 178.344L112.488 209.197L104.871 209.558H100.41L96.8408 237.217L87.9184 248.817H65.6123L56.6899 237.217L54.0132 209.558L42.4141 209.197L46.0339 178.576C46.642 173.433 50.2632 169.15 55.234 167.694C65.298 164.748 70.33 161.449 70.33 157.796C70.33 155.726 70.1865 152.826 69.8994 149.094L84.1104 149.555Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1104 149.555C83.8233 152.84 83.6797 155.522 83.6797 157.601C83.6797 161.383 88.778 164.764 98.9745 167.745C103.847 169.17 107.434 173.316 108.142 178.343L112.488 209.196L104.871 209.558H100.41L96.8408 237.217L87.9184 248.816H65.6123L56.6899 237.217L54.0132 209.558L42.4141 209.196L46.0339 178.576C46.642 173.433 50.2632 169.149 55.234 167.694C65.298 164.748 70.33 161.448 70.33 157.796C70.33 155.726 70.1865 152.825 69.8994 149.093L84.1104 149.555Z",
    fill: "#FDE5BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1831 160.181C62.831 166.849 69.1766 170.146 77.2199 170.07C85.2631 169.994 91.4652 166.698 95.826 160.181L106.934 167.456L112.488 209.274H100.409L97.7327 237.217L88.8103 247.924H66.5042L56.6896 237.217L54.0129 209.274H41.5215L47.0754 168.012L58.1831 160.181Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5203 124.795C85.585 124.795 90.5015 129.711 90.5015 135.776V147.403C90.5015 153.468 85.585 158.384 79.5203 158.384C73.4555 158.384 68.5391 153.468 68.5391 147.403V135.776C68.5391 129.711 73.4555 124.795 79.5203 124.795Z",
    fill: "#FAD2A2"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0047 121.963C83.0694 121.963 87.9859 126.88 87.9859 132.944V144.572C87.9859 150.636 83.0694 155.553 77.0047 155.553C70.9399 155.553 66.0234 150.636 66.0234 144.572V132.944C66.0234 126.88 70.9399 121.963 77.0047 121.963Z",
    fill: "#FDE5BC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4167 137.466H87.1248C85.6978 137.466 84.541 138.623 84.541 140.05V141.342C84.541 142.769 85.6978 143.925 87.1248 143.925H88.4167C89.8437 143.925 91.0006 142.769 91.0006 141.342V140.05C91.0006 138.623 89.8437 137.466 88.4167 137.466Z",
    fill: "#FDE5BC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8835 137.466H65.5916C64.1646 137.466 63.0078 138.623 63.0078 140.05V141.342C63.0078 142.769 64.1646 143.925 65.5916 143.925H66.8835C68.3105 143.925 69.4674 142.769 69.4674 141.342V140.05C69.4674 138.623 68.3105 137.466 66.8835 137.466Z",
    fill: "#FDE5BC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0233 121.901L76.7892 118.025L87.9858 121.901L89.2777 125.346L87.9858 127.544C84.8582 128.407 81.5566 130.04 78.0811 132.444C74.6056 134.848 70.5864 136.645 66.0233 137.835L64.3008 129.653L66.0233 121.901Z",
    fill: "#F13C12"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8173 140.7C83.5308 140.7 84.1092 140.121 84.1092 139.408C84.1092 138.694 83.5308 138.116 82.8173 138.116C82.1038 138.116 81.5254 138.694 81.5254 139.408C81.5254 140.121 82.1038 140.7 82.8173 140.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 148,
    width: 10,
    height: 4
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0047 148.316C78.3858 148.316 79.7669 148.398 81.148 148.563C79.7669 150.287 78.3858 151.149 77.0047 151.149C75.6236 151.149 74.2424 150.287 72.8613 148.563C74.2424 148.398 75.6236 148.316 77.0047 148.316Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0047 148.316C78.3858 148.316 79.7669 148.398 81.148 148.563C79.7669 150.287 78.3858 151.149 77.0047 151.149C75.6236 151.149 74.2424 150.287 72.8613 148.563C74.2424 148.398 75.6236 148.316 77.0047 148.316Z",
    fill: "white"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1903 140.699C71.9038 140.699 72.4823 140.121 72.4823 139.407C72.4823 138.694 71.9038 138.115 71.1903 138.115C70.4768 138.115 69.8984 138.694 69.8984 139.407C69.8984 140.121 70.4768 140.699 71.1903 140.699Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0139 145.763C78.0053 145.763 78.8091 145.117 78.8091 144.87C78.8091 144.624 78.0053 144.424 77.0139 144.424C76.0225 144.424 75.2188 144.624 75.2188 144.87C75.2188 145.117 76.0225 145.763 77.0139 145.763Z",
    fill: "#FAD2A2"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_12311_88307)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 109,
    width: 75,
    height: 74
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M286.209 183C306.644 183 323.209 166.435 323.209 146C323.209 125.565 306.644 109 286.209 109C265.774 109 249.209 125.565 249.209 146C249.209 166.435 265.774 183 286.209 183Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_12311_88307)"
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M286.209 183C306.644 183 323.209 166.435 323.209 146C323.209 125.565 306.644 109 286.209 109C265.774 109 249.209 125.565 249.209 146C249.209 166.435 265.774 183 286.209 183Z",
    fill: "#031D43"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.213 116.765C293.966 116.765 300.252 123.051 300.252 130.804C300.252 131.883 300.127 132.959 299.881 134.01C299.09 137.382 298.339 140.008 297.629 141.889C295.983 146.25 292.328 152.493 286.666 160.617C280.271 152.395 276.16 146.152 274.333 141.889C273.57 140.108 272.827 137.61 272.105 134.395C270.354 126.603 275.252 118.867 283.043 117.117C284.084 116.883 285.147 116.765 286.213 116.765Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 149,
    width: 71,
    height: 100
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M293.319 149.556C293.032 152.841 292.889 155.523 292.889 157.603C292.889 161.385 297.987 164.766 308.183 167.747C313.056 169.171 316.643 173.318 317.351 178.345L321.697 209.198L314.08 209.559H309.619L306.05 237.219L297.127 248.818H274.821L265.899 237.219L263.222 209.559L251.623 209.198L255.243 178.578C255.851 173.434 259.472 169.151 264.443 167.696C274.507 164.749 279.539 161.45 279.539 157.797C279.539 155.728 279.395 152.827 279.108 149.095L293.319 149.556Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.319 149.556C293.032 152.841 292.889 155.523 292.889 157.603C292.889 161.384 297.987 164.766 308.183 167.746C313.056 169.171 316.643 173.317 317.351 178.345L321.697 209.198L314.08 209.559H309.619L306.05 237.218L297.127 248.818H274.821L265.899 237.218L263.222 209.559L251.623 209.198L255.243 178.577C255.851 173.434 259.472 169.151 264.443 167.695C274.507 164.749 279.539 161.45 279.539 157.797C279.539 155.727 279.395 152.827 279.108 149.094L293.319 149.556Z",
    fill: "#CD8B52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.392 160.182C272.04 166.851 278.386 170.147 286.429 170.071C294.472 169.995 300.674 166.699 305.035 160.182L316.143 167.458L321.697 209.275H309.618L306.942 237.218L298.019 247.925H275.713L265.899 237.218L263.222 209.275H250.73L256.284 168.013L267.392 160.182Z",
    fill: "#F9E7A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.729 124.796C294.794 124.796 299.71 129.712 299.71 135.777V147.404C299.71 153.469 294.794 158.386 288.729 158.386C282.665 158.386 277.748 153.469 277.748 147.404V135.777C277.748 129.712 282.665 124.796 288.729 124.796Z",
    fill: "#CB793D"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.214 121.964C292.278 121.964 297.195 126.881 297.195 132.945V144.573C297.195 150.637 292.278 155.554 286.214 155.554C280.149 155.554 275.232 150.637 275.232 144.573V132.945C275.232 126.881 280.149 121.964 286.214 121.964Z",
    fill: "#CD8B52"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M297.626 137.467H296.334C294.907 137.467 293.75 138.624 293.75 140.051V141.343C293.75 142.77 294.907 143.926 296.334 143.926H297.626C299.053 143.926 300.21 142.77 300.21 141.343V140.051C300.21 138.624 299.053 137.467 297.626 137.467Z",
    fill: "#CD8B52"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M276.093 137.467H274.801C273.374 137.467 272.217 138.624 272.217 140.051V141.343C272.217 142.77 273.374 143.926 274.801 143.926H276.093C277.52 143.926 278.676 142.77 278.676 141.343V140.051C278.676 138.624 277.52 137.467 276.093 137.467Z",
    fill: "#CD8B52"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.151 121.902L286.492 118.027L294.505 121.902L298.486 125.347L297.225 136.408C299.565 133.971 297.956 131.231 292.399 128.185C286.841 125.14 281.138 125.901 275.288 130.469C273.254 130.851 272.523 129.785 273.094 127.272C273.666 124.758 274.685 122.969 276.151 121.902Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M285.982 124.531C290.397 124.531 293.976 121.463 293.976 117.679C293.976 113.895 290.397 110.827 285.982 110.827C281.567 110.827 277.988 113.895 277.988 117.679C277.988 121.463 281.567 124.531 285.982 124.531Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M292.026 140.701C292.74 140.701 293.318 140.122 293.318 139.409C293.318 138.695 292.74 138.117 292.026 138.117C291.313 138.117 290.734 138.695 290.734 139.409C290.734 140.122 291.313 140.701 292.026 140.701Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_12311_88307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 148,
    width: 8,
    height: 4
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M286.216 148.317C287.293 148.317 288.369 148.4 289.446 148.564C288.369 150.289 287.293 151.151 286.216 151.151C285.14 151.151 284.063 150.289 282.986 148.564C284.063 148.4 285.14 148.317 286.216 148.317Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_12311_88307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.216 148.317C287.293 148.317 288.369 148.4 289.446 148.564C288.369 150.289 287.293 151.151 286.216 151.151C285.14 151.151 284.063 150.289 282.986 148.564C284.063 148.4 285.14 148.317 286.216 148.317Z",
    fill: "#9C5620"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M280.401 140.701C281.115 140.701 281.693 140.122 281.693 139.409C281.693 138.695 281.115 138.117 280.401 138.117C279.688 138.117 279.109 138.695 279.109 139.409C279.109 140.122 279.688 140.701 280.401 140.701Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.501 136.75C281.682 136.75 282.75 137.006 283.491 137.591C284.122 138.089 284.498 138.829 284.498 139.833C284.498 140.937 284.05 141.936 283.327 142.66C282.604 143.383 281.605 143.83 280.501 143.83C279.397 143.83 278.398 143.383 277.675 142.66C276.951 141.936 276.504 140.937 276.504 139.833C276.504 138.829 276.88 138.089 277.511 137.591C278.251 137.006 279.32 136.75 280.501 136.75Z",
    stroke: "#FFA98C",
    strokeWidth: 0.685185
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M284.611 139.376C285.144 139.072 285.677 138.92 286.21 138.92C286.743 138.92 287.276 139.072 287.809 139.376",
    stroke: "#FFA98C",
    strokeWidth: 0.685185,
    strokeLinecap: "square"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.921 136.75C293.101 136.75 294.17 137.006 294.911 137.591C295.542 138.089 295.918 138.829 295.918 139.833C295.918 140.937 295.47 141.936 294.747 142.66C294.024 143.383 293.024 143.83 291.921 143.83C290.817 143.83 289.818 143.383 289.094 142.66C288.371 141.936 287.924 140.937 287.924 139.833C287.924 138.829 288.3 138.089 288.93 137.591C289.671 137.006 290.74 136.75 291.921 136.75Z",
    stroke: "#FFA98C",
    strokeWidth: 0.685185
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.223 145.763C286.962 145.763 287.561 145.117 287.561 144.871C287.561 144.625 286.962 144.425 286.223 144.425C285.484 144.425 284.885 144.625 284.885 144.871C284.885 145.117 285.484 145.763 286.223 145.763Z",
    fill: "#CB793D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 173.616,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(107.863 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(201.963 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(144.605 109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(294.691 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_12311_88307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(249.209 109)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEeo);
export default __webpack_public_path__ + "static/media/eeo.40e2d9fe81388b0f21635c8231841d96.svg";
export { ForwardRef as ReactComponent };